@for (entry of errorMessagesEntries(); track entry.key) {
  <palantir-text type="negative" size="xs">{{ entry.value }}</palantir-text>
}
